import { Component, ViewChild } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { CrudComponent } from "src/app/components/shared/cruds/crud.component";
import { CrudForm } from "src/app/components/shared/cruds/crud.form";
import { AlertasSwalService } from "src/app/services/alerts.service";
import { SweetAlertOptions } from "sweetalert2";
import { TipoMaterialesService } from "../../catalogs/tipos-materiales/tipos-materiales.service";
import { MaterialsService } from "./materials.service";

@Component({
  selector: "app-materials",
  templateUrl: "./materials.component.html",
  styles: [],
})
export class MaterialsComponent extends CrudComponent<any> {
  public imgDef =
    "https://us.123rf.com/450wm/tvectoricons/tvectoricons1811/tvectoricons181105271/112229760-add-photos-icon-trendy-flat-vector-add-photos-icon-on-white-background-from-general-collection.jpg?ver=6";

  columnId: string = "";
  filtro: string = "";
  realdata: any[];
  list: any[];
  listMateriales: any[] = [];

  @ViewChild("formulario")
  public formulario: CrudForm<any>;
  askRemoveConfig: SweetAlertOptions = {
    title: "Seguro que quieres eliminar este registro?",
    text: "Esta accion es irreversible!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Si",
    cancelButtonText: "No",
  };

  constructor(
    public service: MaterialsService,
    public tiposService: TipoMaterialesService,
    public dialog: MatDialog,
    public alerts: AlertasSwalService
  ) {
    super(service, alerts);
  }

  ngOnInit(): void {
    this.loadRecords();
    this.loadTiposMateriales();
  }

  loadTiposMateriales() {
    this.tiposService.get().subscribe(
      (resultData) => {
        this.listMateriales = resultData;
      },
      (err) => {
        this.alerts.error("error", err.error.Message);
      }
    );
  }
  loadRecords() {
    this.service.get().subscribe(
      (resultData) => {
        this.realdata = resultData;
        this.filterdata();
      },
      (err) => {
        this.alerts.error("error", err.error.Message);
      }
    );
  }
  filterdata() {
    let filterdata = this.realdata;

    if (this.filtro.trim().length > 0)
      filterdata = filterdata.filter(
        (f) =>
          (f.Descripcion.toLocaleLowerCase() as string).indexOf(
            this.filtro.toLocaleLowerCase().trim()
          ) > -1 ||
          ((f.NoParteInterno ?? "").toLocaleLowerCase() as string).indexOf(
            this.filtro.toLocaleLowerCase().trim()
          ) > -1 ||
          ((f.Ubicacion ?? "").toLocaleLowerCase() as string).indexOf(
            this.filtro.toLocaleLowerCase().trim()
          ) > -1 ||
          ((f.Tags ?? "").toLocaleLowerCase() as string).indexOf(
            this.filtro.toLocaleLowerCase().trim()
          ) > -1
      );
    this.list = filterdata;
  }

  saveForm(e: { mode: string; value: any; file: File }) {
    if (e.mode == "create") {
      if (e.file) this.guardarConImagen(e.value, e.file);
      else this.guardar(e.value);
    } else if (e.mode == "update") {
      if (e.file) this.actualizarConImagen(e.value, e.file);
      else this.actualizar(e.value);
    }
  }
  guardar(row: any) {
    this.service.add(row).subscribe(
      (next) => {
        this.alerts.correcta("Creado", "Accion realizada correctamente");
        this.formulario.setStanby();
        this.loadRecords();
      },
      (err) => {
        this.alerts.error("error", err.error.Message);
      }
    );
  }
  actualizar(row: any) {
    this.service.update(row).subscribe(
      (next) => {
        this.alerts.correcta("Actualizado", "Accion realizada correctamente");
        this.formulario.setStanby();
        this.loadRecords();
      },
      (err) => {
        this.alerts.error("error", err.error.Message);
      }
    );
  }

  guardarConImagen(row: any, imagen: File) {
    this.service.addWithFile(row, imagen).subscribe(
      (next) => {
        this.alerts.correcta("Creado", "Accion realizada correctamente");
        this.formulario.setStanby();
        this.loadRecords();
      },
      (err) => {
        this.alerts.error("error", err.error.Message);
      }
    );
  }

  actualizarConImagen(row: any, imagen: File) {
    this.service.updateWithFile(row, imagen).subscribe(
      (next) => {
        this.alerts.correcta("Actualizado", "Accion realizada correctamente");
        this.formulario.setStanby();
        this.loadRecords();
      },
      (err) => {
        this.alerts.error("error", err.error.Message);
      }
    );
  }

  errorHandler(event) {
    event.target.src = this.imgDef;
  }

  setUpdate(row: any) {
    this.formulario.setUpdate(row);
  }
  askRemove(row: any) {
    this.alerts.ask(this.askRemoveConfig).then((result) => {
      if (result.isConfirmed) {
        this.eliminar(row);
      }
    });
  }

  eliminar(row: any) {
    this.service.delete(row[this.columnId]).subscribe(
      (next) => {
        this.alerts.correcta("Eliminado", "Accion realizada correctamente");
        this.loadRecords();
      },
      (err) => {
        this.alerts.error("error", err.error.Message);
      }
    );
  }

  activar(row: any) {
    this.service.activate(row[this.columnId]).subscribe(
      (next) => {
        this.alerts.correcta("Activado", "Accion realizada correctamente");
        this.loadRecords();
      },
      (err) => {
        this.alerts.error("error", err.error.Message);
      }
    );
  }
}
